// 260703nrai: poll for new messages and show live toasts
// 260709nrai: poll on app requests instead of fixed interval; defer until toast_manager exists

const MESSAGES_POLL_DEBOUNCE_MS = 400;

function initMessagesPoll() {
  const pollUrl = document.body.dataset.messagesPollUrl;
  if (!pollUrl) return;

  const inboxUrl = document.body.dataset.messagesInboxUrl || '/messages/inbox?tab=in&unread_only=false';
  const pollStorageKey = 'messages_poll_last_at';
  const shownStorageKey = 'messages_toast_shown';
  const storedPollAt = sessionStorage.getItem(pollStorageKey);
  let lastPollAt = storedPollAt || new Date(Date.now() - 5 * 60 * 1000).toISOString();
  const shownIds = new Set(JSON.parse(sessionStorage.getItem(shownStorageKey) || '[]'));
  let pollInFlight = false;
  let pollScheduled = null;

  function saveShownIds() {
    sessionStorage.setItem(shownStorageKey, JSON.stringify(Array.from(shownIds).slice(-200)));
  }

  function isMessagesPollRequest(url) {
    if (!url) return false;
    return String(url).includes('/messages/poll');
  }

  function poll() {
    if (!window.toast_manager) return;
    if (pollInFlight) return;

    pollInFlight = true;
    fetch(`${pollUrl}?since=${encodeURIComponent(lastPollAt)}`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then((response) => {
        if (!response.ok) throw new Error(`poll ${response.status}`);
        return response.json();
      })
      .then((payload) => {
        const messages = payload.new_messages || [];
        let latestCreatedAt = lastPollAt;

        messages.forEach((message) => {
          if (message.created_at && message.created_at > latestCreatedAt) {
            latestCreatedAt = message.created_at;
          }
          if (shownIds.has(String(message.id))) return;
          shownIds.add(String(message.id));
          saveShownIds();

          const link = `<a href="${inboxUrl}&amp;id=${message.id}" class="clickable_text">Jetzt ansehen.</a>`;
          window.toast_manager.push_many([{
            kind: 'success',
            html: `Sie haben eine neue Nachricht von ${message.from} mit dem Betreff ${message.subject} erhalten. ${link}`,
            duration_ms: 8000
          }]);
        });

        lastPollAt = latestCreatedAt !== lastPollAt ? latestCreatedAt : new Date().toISOString();
        sessionStorage.setItem(pollStorageKey, lastPollAt);
      })
      .catch(() => {})
      .finally(() => {
        pollInFlight = false;
      });
  }

  function schedulePoll() {
    if (pollScheduled) return;
    pollScheduled = window.setTimeout(() => {
      pollScheduled = null;
      poll();
    }, MESSAGES_POLL_DEBOUNCE_MS);
  }

  function hookRequestPolling() {
    if (window.__messagesPollHooksInstalled) return;
    window.__messagesPollHooksInstalled = true;

    const originalFetch = window.fetch;
    window.fetch = function messagesPollFetch(...args) {
      const request = args[0];
      const url = typeof request === 'string' ? request : request?.url;
      const result = originalFetch.apply(this, args);

      if (!isMessagesPollRequest(url)) {
        result.finally(() => schedulePoll());
      }
      return result;
    };

    if (window.jQuery) {
      window.jQuery(document).ajaxComplete((_event, _xhr, settings) => {
        if (!isMessagesPollRequest(settings?.url)) {
          schedulePoll();
        }
      });
    }
  }

  function startWhenReady() {
    if (!window.toast_manager) {
      window.setTimeout(startWhenReady, 50);
      return;
    }

    hookRequestPolling();
    poll();
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') schedulePoll();
    });
  }

  startWhenReady();
}

window.initMessagesPoll = initMessagesPoll;

export { initMessagesPoll };
